// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"6351a5df","914":"8b6d5bfd"}[chunkId] + ".chunk.css";
};